import React, { memo, useState } from "react";

import {
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CInput,
  CTooltip
} from "@coreui/react";
import { Handle, useStoreState } from "react-flow-renderer";
import { RiAddFill, RiCheckboxCircleFill, RiRocket2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";

import URL from "../../config/api";
import { baseDate, baseToDateTimeLocal, formatDate } from "../../utils/date";
import ChooseNodeModal from "../ChooseNodeModal";
import EditNodeModal from "../EditNodeModal";
import ViewNodeModal from "../ViewNodeModal";

export default memo(
  ({ id, data = {}, selected, isConnectable, yPos, xPos }) => {
    const user = useSelector(state => state.user.user);

    const [showSource, setShowSource] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [chooseModal, setChooseModal] = useState(false);
    const [createActivity, setCreateActivity] = useState(false);
    const selectedElements = useStoreState(store => store.selectedElements);
    const opacity = data.doing && !data.active ? 0.7 : 1;

    const showEditModal = () => {
      data.setDrag(false);
      setCreateActivity(false);
      setEditModal(true);
    };

    const showViewModal = () => {
      data.setDrag(false);
      setViewModal(true);
    };

    const showCreateModal = () => {
      data.setDrag(false);
      setCreateActivity(true);
      setEditModal(true);
    };

    const showChooseModal = () => {
      data.setDrag(false);
      setChooseModal(true);
    };

    const onCreate = activity => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);

      data.addElement(
        {
          id: (Math.random() + 1).toString(36).substring(7),
          type: "activity",
          position: { x: xPos, y: yPos + 250 },
          data: {
            temporary: true,
            activity,
            start: null,
            end: null
          }
        },
        id
      );
    };

    const onEdit = activity => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);

      data.editElement({
        id,
        type: "start",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          activity
        }
      });
    };

    const onClose = () => {
      data.setDrag(true);
      setEditModal(false);
      setChooseModal(false);
      setViewModal(false);
    };

    const toggleStartDate = () => {
      data.editElement({
        id,
        type: "start",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          start: data.start ? null : baseDate(new Date())
        }
      });
    };

    const toggleEndDate = () => {
      data.editElement({
        id,
        type: "start",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          end: data.end ? null : baseDate(new Date())
        }
      });
    };

    const changeStartDate = e => {
      data.editElement({
        id,
        type: "start",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          start: baseDate(new Date(e.target.value))
        }
      });
    };

    const changeEndDate = e => {
      data.editElement({
        id,
        type: "start",
        position: { x: xPos, y: yPos },
        data: {
          ...data,
          end: baseDate(new Date(e.target.value))
        }
      });
    };

    const executed =
      data.activity?.executions?.length > 0 &&
      data.activity?.executions[0].completion_percentage >= 100;

    const late = data.end && new Date(data.end) < new Date();
    const notStarted = data.start && new Date(data.start) > new Date();

    const onClick = params => {
      if (notStarted) {
        toastr.warning("Atenção", "A atividade ainda não foi iniciada");
        return;
      }

      if (late) {
        toastr.warning("Atenção", "A atividade já encerrou");
        return;
      }

      data.onClick(params);
    };

    return (
      <>
        {editModal && (
          <EditNodeModal
            show={editModal}
            id={createActivity ? null : data.activity?.id}
            onCreate={onCreate}
            onEdit={onEdit}
            onClose={onClose}
          />
        )}
        {chooseModal && (
          <ChooseNodeModal
            show={chooseModal}
            onSelect={onCreate}
            onClose={onClose}
          />
        )}
        {viewModal && (
          <ViewNodeModal
            show={viewModal}
            id={data.activity?.id}
            onClose={onClose}
          />
        )}
        <CCard
          color="primary"
          className={`m-0 ${!data.doing && selected ? "shadow-sm" : ""}${
            data.doing ? " hover-shadow" : ""
          }`}
          style={{
            transition: "0.15s ease-in-out",
            opacity,
            width: "200px",
            cursor: data.doing
              ? "pointer"
              : !data.editable
              ? "pointer"
              : undefined
          }}
          onClick={() =>
            data.doing && data.active
              ? onClick(data.activity?.id)
              : !data.doing && !data.editable
              ? showViewModal()
              : null
          }
        >
          <CCardHeader
            className="d-flex align-items-center p-2"
            style={{
              borderBottom:
                (data.activity?.items && data.activity?.items.length > 0) ||
                (data.activity?.currentUsers &&
                  data.activity?.currentUsers.length > 0)
                  ? undefined
                  : 0
            }}
          >
            {executed ? (
              <RiCheckboxCircleFill color="var(--success)" className="mr-2" />
            ) : (
              <RiRocket2Fill color="white" className="mr-2" />
            )}
            <span className="flex-1 text-ellipsis">{data.activity?.name}</span>
            {data.editable && (
              <CDropdown>
                <CDropdownToggle
                  color="primary"
                  className=" ml-2 card-header-action remove-caret"
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none"
                  }}
                >
                  <i className="fa fa-ellipsis-v text-white"></i>
                </CDropdownToggle>
                <CDropdownMenu
                  placement="bottom-start"
                  style={{ cursor: "default" }}
                >
                  {data.activity?.user_id === user.id && (
                    <>
                      <CDropdownItem onClick={showEditModal}>
                        Editar
                      </CDropdownItem>
                      <CDropdownDivider />
                    </>
                  )}
                  <div
                    style={{
                      paddingLeft: "1.25rem",
                      paddingRight: "1.25rem",
                      whiteSpace: "nowrap"
                    }}
                    className="mb-1"
                  >
                    <div className="small text-muted w-100 d-flex justify-content-between">
                      Data de início
                      <a href="#" className="ml-3" onClick={toggleStartDate}>
                        {data.start ? "Remover" : "Adicionar"}
                      </a>
                    </div>
                    {data.start && (
                      <CInput
                        type="datetime-local"
                        className="mt-2 mb-2"
                        value={baseToDateTimeLocal(data.start)}
                        onChange={changeStartDate}
                      />
                    )}
                  </div>
                  <div
                    style={{
                      paddingLeft: "1.25rem",
                      paddingRight: "1.25rem",
                      whiteSpace: "nowrap"
                    }}
                    className="mb-1"
                  >
                    <div className="small text-muted w-100 d-flex justify-content-between">
                      Data de fim
                      <a href="#" className="ml-3" onClick={toggleEndDate}>
                        {data.end ? "Remover" : "Adicionar"}
                      </a>
                    </div>
                    {data.end && (
                      <CInput
                        type="datetime-local"
                        className="mt-2 mb-2"
                        value={baseToDateTimeLocal(data.end)}
                        onChange={changeEndDate}
                      />
                    )}
                  </div>
                </CDropdownMenu>
              </CDropdown>
            )}
          </CCardHeader>
          <CCardBody className="d-flex flex-column align-items-start justify-content-center p-2 small">
            <div
              className={
                !executed && notStarted
                  ? "opacity-half"
                  : !executed && late
                  ? "text-danger"
                  : ""
              }
            >
              <strong>Início: </strong>
              {data.start ? formatDate(data.start) : "Qualquer momento"}
            </div>
            <div
              className={
                !executed && notStarted
                  ? "opacity-half"
                  : !executed && late
                  ? "text-danger"
                  : ""
              }
            >
              <strong>Fim: </strong>
              {data.end ? formatDate(data.end) : "Qualquer momento"}
            </div>
          </CCardBody>
          {data.activity?.items && data.activity?.items.length > 0 && (
            <CCardBody className="d-flex align-items-center justify-content-start px-2 pb-2 pt-0">
              {data.activity.items.map(item => (
                <CTooltip content={item.name}>
                  <div
                    className={`bg-${item.type?.color} rounded-circle d-flex align-items-center justify-content-center mr-2`}
                    style={{ width: 20, height: 20 }}
                  >
                    <i className={`fa fa-${item.type?.icon}`}></i>
                  </div>
                </CTooltip>
              ))}
            </CCardBody>
          )}
          {data.activity?.currentUsers &&
            data.activity?.currentUsers.length > 0 && (
              <CCardFooter
                className="d-flex align-items-center justify-content-start p-2 bg-primary"
                style={{ borderColor: "rgba(0, 0, 0, 0.125)" }}
              >
                {data.activity.currentUsers.map(user => (
                  <img
                    src={
                      URL.img + (user.photo || "uploads/users/profileEmpty.jpg")
                    }
                    className="bg-warning rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                      width: 24,
                      height: 24,
                      border: "2px solid var(--primary)"
                    }}
                  />
                ))}
              </CCardFooter>
            )}
        </CCard>
        <Handle
          type="source"
          position="bottom"
          isConnectable={data.editable && isConnectable}
          style={
            data.editable
              ? {
                  width: 10,
                  height: 10,
                  background: "var(--light)",
                  border: `2px solid ${
                    data.activeOutput || data.editable
                      ? "var(--primary)"
                      : "var(--secondary)"
                  }`,
                  transform: "translate(-6px, 6px)"
                }
              : {
                  width: 0,
                  height: 0,
                  background: "transparent",
                  borderColor: "transparent"
                }
          }
          onMouseEnter={() => setShowSource(true)}
          onMouseLeave={() => setShowSource(false)}
        >
          {data.editable && (
            <div
              style={{
                width: 10,
                transform: "translate(-2px, 8px)",
                opacity: 1,
                transition: "0.15s ease-in-out"
              }}
              className="bg-light d-flex flex-column align-items-center justify-content-center"
              onClick={e => e.stopPropagation()}
            >
              {(true || showSource) && (
                <>
                  <div
                    className={`${
                      data.activeOutput || data.editable
                        ? "bg-primary"
                        : "bg-secondary"
                    }`}
                    style={{ width: 2, height: 10 }}
                  ></div>
                  <CDropdown>
                    <CDropdownToggle
                      color="white"
                      style={{ width: "20px", height: "20px" }}
                      className="rounded-circle p-0 small text-muted d-flex align-items-center justify-content-center card m-0"
                      caret={false}
                    >
                      <RiAddFill size={16} />
                    </CDropdownToggle>
                    <CDropdownMenu placement="bottom">
                      <CDropdownItem onClick={showCreateModal}>
                        Criar nova atividade
                      </CDropdownItem>
                      <CDropdownItem onClick={showChooseModal}>
                        Escolher uma atividade
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </>
              )}
            </div>
          )}
        </Handle>
      </>
    );
  }
);
